import { Action, isType } from 'ts-action'
import { IModalsReducer, TModalMap } from 'models/Modals'
import { CloseAllModals, CloseModal, KillModal, OpenModal, RefreshModalConfig } from './actions'

const initialState: IModalsReducer = {
  modals: {},
}

export const modalsReducer = (state = initialState, action: Action): IModalsReducer => {
  if (isType(action, OpenModal)) {
    const { payload: config } = action
    return {
      ...state,
      modals: { ...state.modals, [config.identifier]: { ...config, isOpen: true } },
    }
  }

  if (isType(action, CloseModal)) {
    const { payload: identifier } = action
    const modalConfig = { ...state.modals[identifier] }

    if (modalConfig) {
      return {
        ...state,
        modals: { ...state.modals, [identifier]: { ...modalConfig, isOpen: false } },
      }
    }
    return state
  }

  if (isType(action, KillModal)) {
    const { payload: identifier } = action
    const modals = { ...state.modals }
    const { [identifier]: _, ...rest } = modals

    return { ...state, modals: rest }
  }

  if (isType(action, RefreshModalConfig)) {
    const { payload: config } = action
    const modalConfig = { ...state.modals[config.identifier] }

    if (modalConfig) {
      return {
        ...state,
        modals: { ...state.modals, [config.identifier]: { ...modalConfig, ...config } },
      }
    }
    return state
  }

  if (isType(action, CloseAllModals)) {
    const updated: TModalMap = {}

    for (const [key, modalConfig] of Object.entries(state.modals)) {
      updated[key] = { ...modalConfig, isOpen: false }
    }

    return { ...state, modals: updated }
  }

  return state
}
